import { FeatureCollection } from "../featuretree/internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { FrameFeature2 } from "./internal";
/**
 * Handels add/delete of FrameFeatures that belong to this collection
 * @class FrameFeatureCollection
 * @constructor
 * @extends FeatureCollection
 */
export class FrameFeatureCollection2 extends FeatureCollection {
    /**
     * @constructor
     *
     * @param {Scene} scene
     * @param {FeatureStyle=} style The style-Object for the fc.
     * @param {FeatureStyle=} highlightstyle The highlightstyle-Object for the fc.
     * @param {string=} name The name of the fc.
     * @param {boolean=} pickable set this to false if all features in this collection shouldn't be pickable
     * @param {FeatureHandler} parent
     */
    constructor(scene, style, highlightstyle, name, pickable, parent) {
        super(scene, style, highlightstyle, name, pickable, parent);
        /**
         * events-id's to unsubscribe events on destroy
         */
        this._geoframechangedevt = null;
        this._geoframecollectionchangedevt = null;
        this._imagechangedevt = null;
        /**
         * The Array of frame-features that this Collection is managing. Overrides the features-array of FeatureCollection
         * @property {Array.<FrameFeature2>} features
         */
        this.features = [];
        // registering events to call the updateframe-function on frame change.
        this._geoframechangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["GEOFRAMECHANGED"], (geoframe) => {
            this.updateframe(geoframe);
        }, this);
        this._geoframecollectionchangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, (geoframecollection) => {
            this.updateframe(geoframecollection.getCurrentGeoFrame());
        }, this);
        this._imagechangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["IMAGECHANGED"], (activeimage) => {
            this.updateframe(this.scene.getCurrentGeoframe());
        }, this);
    }
    /**
     * Creates a new empty FrameFeature2 object.
     *
     * @return {FrameFeature2}
     */
    createFeature() {
        const feature = new FrameFeature2(this);
        this.features.push(feature);
        return feature;
    }
    /**
     * Updates the Featurecollection
     */
    update() {
        super.update();
        if (this.parentfeaturehandler.parentscene.getCurrentGeoframe()) {
            this.updateframe(this.parentfeaturehandler.parentscene.getCurrentGeoframe());
        }
    }
    /**
     * Adds/Removes all FrameFeatures in the collection to the scene according to the current GeoFrame.
     */
    updateframe(geoframe) {
        for (let i = 0; i < this.features.length; i++) {
            this.features[i].updateframe(geoframe);
        }
    }
    /**
     *  Destroys the featurecollection. Unsubscribes registered events.
     */
    destroy() {
        super.destroy();
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this._geoframechangedevt);
        this._geoframechangedevt = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this._geoframecollectionchangedevt);
        this._geoframecollectionchangedevt = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.IMAGECHANGED, this._imagechangedevt);
        this._imagechangedevt = null;
    }
}
//# sourceMappingURL=framefeaturecollection2.js.map